module.exports = __webpack_public_path__ + "static/media/aithyia-1.84a4a3ef.jpg";